import { MemberType } from "next-lib";

export const cdnURL = "https://cdn.martvanweeghel.nl";

// Routes for the app
export const appPath = {
  default: "/",
  members: "/leden",
  member: "/leden/:memberUrl",
  events: "/evenementen",
  photos: "/fotos",
  contact: "/contact",
  privacy: "/privacy",
};

export function generateMemberUrl(member: MemberType) {
  return appPath.member.replace(
    ":memberUrl",
    `${member.firstName.toLowerCase().split(" ").join("_")}_${member.lastName
      .toLowerCase()
      .split(" ")
      .join("_")}`
  );
}
